module.exports = __webpack_public_path__ + "img/hair2.27bc6d83.png";